import { emailConfirmedComponentOptions, EMAIL_CONFIRMED_COMPONENT } from './email-confirmed.component';
import { EmailConfirmedService, EMAIL_CONFIRMED_SERVICE } from './email-confirmed.service';
import * as angular from "angular";
import { configRoute } from "./email-confirmed.router";

import uiRouterModule from "@uirouter/angularjs";

export default angular
    .module("board.web.admin.emailconfirmed", [
        uiRouterModule
    ])
    .service(EMAIL_CONFIRMED_SERVICE, EmailConfirmedService)
    .config(configRoute)
    .name


// WEBPACK FOOTER //
// ./app/email-confirmed/email-confirmed.module.ts